import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Button from "../components/UiElements/Button";
import Input from "../components/UiElements/Input";
import config from "../config";
import { tokens } from "../design-system/tokens";

const pageStyle: React.CSSProperties = {
  direction: "rtl",
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 24,
  backgroundColor: tokens.colors.background,
};

const cardStyle: React.CSSProperties = {
  width: "100%",
  maxWidth: 400,
  padding: 24,
  borderRadius: tokens.borderRadius.xl,
  backgroundColor: tokens.colors.surface,
  boxShadow: tokens.shadows.md,
};

async function publicRequest<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${config.backendUrl}${path}`, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(init?.headers || {}),
    },
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data?.message || "Request failed");
  }
  return data as T;
}

const TestDriveAdminHelp: React.FC = () => {
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async () => {
    if (!phone.trim()) {
      setError("יש להזין מספר טלפון");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await publicRequest("/test-drive/admin-help", {
        method: "POST",
        body: JSON.stringify({
          phone: phone.trim(),
          name: name.trim() || undefined,
        }),
      });
      setDone(true);
    } catch (err: any) {
      setError(err?.message || "שגיאה בפתיחת שיחה עם נציג");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        <Typography sx={{ ...tokens.typography.h6, mb: 2, textAlign: "center" }}>
          פנייה לנציג
        </Typography>
        {done ? (
          <Typography sx={{ ...tokens.typography.body, textAlign: "center" }}>
            מייד יתפנה נציג לשיחה. ניתן לחזור ל-WhatsApp.
          </Typography>
        ) : (
          <>
            <div style={{ marginBottom: 16 }}>
              <Typography sx={{ ...tokens.typography.bodySmall, mb: 0.5 }}>טלפון</Typography>
              <Input
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                color="outline"
                size="medium"
                rtl
              />
            </div>
            <div style={{ marginBottom: 16 }}>
              <Typography sx={{ ...tokens.typography.bodySmall, mb: 0.5 }}>שם</Typography>
              <Input
                value={name}
                onChange={(e) => setName(e.target.value)}
                color="outline"
                size="medium"
                rtl
              />
            </div>
            {error ? (
              <Typography sx={{ color: tokens.colors.error, mb: 2, fontSize: 14 }}>{error}</Typography>
            ) : null}
            <Button
              label="התחל שיחה עם נציג"
              color="primary"
              size="medium"
              width="100%"
              onClick={submit}
              disabled={loading}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default TestDriveAdminHelp;
